export default __webpack_public_path__ + "static/rule-04-helper-1ea720372ad998e06b82ffdbf6233893.png";